import { render, staticRenderFns } from "./business-details.vue?vue&type=template&id=2d51431e&scoped=true"
import script from "./business-details.vue?vue&type=script&lang=js"
export * from "./business-details.vue?vue&type=script&lang=js"
import style0 from "./business-details.vue?vue&type=style&index=0&id=2d51431e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d51431e",
  null
  
)

export default component.exports